import React from 'react'
import { HeroAside } from '../../Components/Aside'
import HeroMask from '../../Components/HeroMask'

function TeamHero({ content }) {
  return (
    <section id={'teamHero'}>
      <HeroImage src={content.img.src} />
      <HeroAside content={content.main} />
    </section>
  )
}

function HeroImage({ src }) {
  return (
    <div id={'hero-video-container'}>
      <img id={'newlab'} src={src} alt={'New Lab'} />\
      <HeroMask />
    </div>
  )
}

export default TeamHero



// WEBPACK FOOTER //
// ./src/Views/Company/TeamHero.js